module.exports = __webpack_public_path__ + "static/media/logo-white.92191715.svg";